// Tiny presentational lookups for detail/review screens that only have an id to
// show (e.g. re-opening a POSTED document's lines). Each is a thin wrapper over the
// matching single-record hook in ../api — react-query dedupes identical ids into one
// request, so rendering the same product across several lines costs one fetch.
import { Text } from '@mantine/core';
import { useCostCentre, useLocation, useProduct, useSite } from '../api';

export function ProductName({ id }: { id: string }) {
  const { data, isLoading } = useProduct(id);
  return <Text span>{data ? `${data.sku} — ${data.name}` : isLoading ? '…' : id}</Text>;
}

export function LocationName({ id }: { id: string }) {
  const { data, isLoading } = useLocation(id);
  return <Text span>{data ? `${data.code} — ${data.name}` : isLoading ? '…' : id}</Text>;
}

export function SiteName({ id }: { id: string }) {
  const { data, isLoading } = useSite(id);
  return <Text span>{data ? `${data.code} — ${data.name}` : isLoading ? '…' : id}</Text>;
}

export function CostCentreName({ id }: { id: string }) {
  const { data, isLoading } = useCostCentre(id);
  return <Text span>{data ? `${data.code} — ${data.name}` : isLoading ? '…' : id}</Text>;
}
